import {Component, Input, OnInit} from '@angular/core';
import {Constants} from "../../../utils/constants";
import {Address} from "../../../services/order.service";
import {CoreDataService} from "../../../services/wrapper/core-data.service";
import {Utilities} from "../../../utils/utilities";

@Component({
  selector: 'app-only-address',
  templateUrl: './only-address.component.html',
  styleUrls: ['./only-address.component.scss']
})
export class OnlyAddressComponent implements OnInit {
  @Input() address:Address;
  @Input() title: string;
  @Input() enableEdit: boolean = true;

  public isEdit = false;
  public countries: any[];
  public cities: any[];
  public addressTypes: any[];
  public country;
  public addressType;

  constructor(  private coreDataService:CoreDataService) {
    this.countries = Utilities.createMultiSelectElements(coreDataService.getLocalizations(), 'code', 'code');
    this.cities = Constants.ADDRESS_CONST.CITIES;
    this.addressTypes = Constants.ADDRESS_CONST.ADDRESS_TYPES;
  }

  ngOnInit() {
    this.isEdit = this.address.country == null && this.enableEdit;
    if(this.address.country != null){
      this.country = [{id:this.address.country, itemName:this.address.country}];
    }
    if(this.address.addressType != null){
      this.addressType = [{id:this.address.addressType, itemName:this.address.addressType}];
    }
  }

  refreshAddressType($event: any) {
    this.address.addressType = $event.id;
  }

  refreshCountry($event: any) {
    this.address.country = $event.id;
  }
}
